(function() {
    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .factory('ResearchUtilities', ResearchUtilities);

    function ResearchUtilities() {
        /**
         * This function determines if the label content should be displayed. Label could
         * be duration or repetition. This function will return true if it should be displayed
         * and false otherwise.
         * @param {type} label
         * @param {type} value
         * @param {type} defaultValue
         * @returns {Boolean}
         */
        function displayQuantityType(label, value, defaultValue) {
            if ((angular.isDefined(value) &&
                    value === label) ||
                    angular.isDefined(defaultValue) &&
                    !angular.isDefined(value) &&
                    defaultValue === label) {
                return true;
            }
            return false;
        }

        /**
         * This function prunes the exerciseTemplates parameter, removing
         * inherited property values if they may be overriden by the default
         * exercise values. This can happen when the exerciseTemplate value
         * is equal to the default exercise value for the same property.
         * @param {type} exerciseTemplates
         * @returns {undefined} none
         */
        function updateExerciseTemplates(exerciseTemplates) {
            var inheritedPropertyNames = ['instructions', 'cuesAndTips'];

            angular.forEach(exerciseTemplates, function(exerciseTemplate) {
                angular.forEach(inheritedPropertyNames, function(propertyName) {
                    // remove property from prescription exercise if it is not defined or != default
                    if (!angular.isDefined(exerciseTemplate[propertyName]) ||
                            exerciseTemplate[propertyName] === exerciseTemplate.exercise[propertyName]) {
                        delete exerciseTemplate[propertyName];
                    }

                    if (!angular.isDefined(exerciseTemplate.ttsInstructions)) {
                        exerciseTemplate.ttsInstructions = exerciseTemplate.exercise.ttsInstructions;
                    }

                    if (!angular.isDefined(exerciseTemplate.ttsCuesAndTips)) {
                        exerciseTemplate.ttsCuesAndTips = exerciseTemplate.exercise.ttsCuesAndTips;
                    }
                });
            });
        }

        var quantityTypes = ['Reps', 'Duration'];

        function getQuantityType(containingModel) {
            if (containingModel.quantityType === 'Repetitions') {
                return 'Reps';
            }
            else if (containingModel.quantityType === 'Duration') {
                return 'Duration';
            }
            else {
                return 'None';
            }
        }

        function setQuantityType(state, containingModel, containingForm) {
            if (state === 'Reps') {
                containingModel.quantityType = 'Repetitions';
                containingForm.$setDirty();
            }
            else if (state === 'Duration') {
                containingModel.quantityType = 'Duration';
                containingForm.$setDirty();
            }
        }

        function getResistanceItemValue(containingModel, containingModelDefault) {
            if (angular.isDefined(containingModel) && containingModel.resistanceItemValue) {
                return containingModel.resistanceItemValue;
            }
            else if (angular.isDefined(containingModelDefault) && containingModelDefault.resistanceItemValue) {
                return containingModelDefault.resistanceItemValue;
            }
            else {
                return 'None';
            }
        }

        function setResistanceItemValue(state, containingModel, containingForm) {
            if (angular.isDefined(containingModel.resistanceItemValue) && 'None' === state) {
                delete containingModel.resistanceItemValue;
                containingForm.$setDirty();
            }
            else if ((angular.isUndefined(containingModel.resistanceItemValue) && 'None' !== state) || (angular.isDefined(containingModel.resistanceItemValue) && containingModel.resistanceItemValue !== state)) {
                containingModel.resistanceItemValue = state;
                containingForm.$setDirty();
            }
        }

        function getControlId(prefix, string, parentIndex, index) {
            return prefix +
                    string +
                    (angular.isNumber(parentIndex) ? '_parentIndex' + parentIndex : '') +
                    (angular.isNumber(index) ? '_index' + index : '');
        }

        return {
            updateExerciseTemplates: updateExerciseTemplates,
            displayQuantityType: displayQuantityType,
            getQuantityType: getQuantityType,
            setQuantityType: setQuantityType,
            quantityTypes: quantityTypes,
            getResistanceItemValue: getResistanceItemValue,
            setResistanceItemValue: setResistanceItemValue,
            getControlId: getControlId
        };
    }
})();